<script setup lang="ts">
const props = defineProps<{
	timezones: string[]
}>()

const { user } = useUser()

const form = useForm({
	method: 'PUT',
	url: route('user-preferences.update'),
	fields: {
		timezone: user.value.timezone,
	},
	errorBag: 'updatePreferences',
	reset: false,
})
</script>


					<script lang="ts">
					import __hybridly_layout_0 from '~/resources/layouts/default.vue';
					export default { layout: [__hybridly_layout_0] }
					</script>
					<template>
				
	<content-wrapper>
		<user-submenu />

		<ui-form variant="settings" @submit.prevent="form.submit">
			<ui-form-settings-item>
				<template #label>
					<ui-label for="name">
						{{ t('validation.attributes.timezone') }}
					</ui-label>
				</template>

				<template #description>
					{{ t('forms.user_preferences.timezone_description') }}
				</template>

				<ui-select v-model="form.fields.timezone">
					<ui-select-trigger>
						<ui-select-value :placeholder="t('forms.user_preferences.select_timezone')" />
					</ui-select-trigger>
					<ui-select-content>
						<ui-select-item v-for="timezone in props.timezones" :key="timezone" :value="timezone">
							{{ timezone }}
						</ui-select-item>
					</ui-select-content>
				</ui-select>
				<ui-form-error :message="form.errors.timezone" />
			</ui-form-settings-item>

			<ui-separator />

			<ui-button :loading="form.processing" class="w-fit" @click="form.submit">
				{{ t('app.buttons.save') }}
				<template #icon>
					<i-ph-arrow-right />
				</template>
			</ui-button>
		</ui-form>
	</content-wrapper>
</template>
